var render, staticRenderFns
import script from "./ProductTemplateBuilder.vue?vue&type=script&lang=js"
export * from "./ProductTemplateBuilder.vue?vue&type=script&lang=js"
import style0 from "./ProductTemplateBuilder.vue?vue&type=style&index=0&id=0704d8ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0704d8ef",
  null
  
)

export default component.exports